export default {"src":"/_next/static/media/payments.170e6b58.svg","height":164,"width":308,"blurWidth":0,"blurHeight":0};